// extracted by mini-css-extract-plugin
export default {"canDrop":"_1NzmFd4nh_EYfC7KB6fJqE","isOver":"_2glkzm1GiBCMVHPJCrYOI_","childless":"_3tx-7fXWOGWlpPdsw40Mcu"};